import {useQuery} from 'react-query';
import {getListLoanRequest} from './getListLoanRequest';

const useGetListLoanRequest = (
  payload?: IListLoanRequestPayload,
  caching?: 'no-cache',
) => {
  const {data, isLoading, isFetching, isFetched, refetch, isSuccess} = useQuery(
    ['get-list-loan-request', payload],
    () => getListLoanRequest(payload),
    {
      cacheTime: caching === 'no-cache' ? 0 : 300000,
      staleTime: caching === 'no-cache' ? 0 : 60000,
      refetchOnReconnect: caching === 'no-cache',
      refetchInterval: caching === 'no-cache' ? 0 : undefined,
    },
  );

  return {
    data,
    isLoading,
    isFetching,
    isFetched,
    refetch,
    isSuccess,
  };
};

export default useGetListLoanRequest;
